<template>
  <section :class="backgroundClasses">
    <div
      :class="[
        'xl:grid xl:gap-19 xl:overflow-hidden max-w-300 mx-auto',
        {
          'xl:grid-cols-[50%_1fr]': !content.reverse,
          'xl:grid-cols-[1fr_50%]': content.reverse,
        },
      ]"
    >
      <button
        :class="[
          'relative cursor-pointer overflow-hidden mb-5 xl:mb-0 lg:min-h-90 lg:max-h-150',
          { 'order-2': content.reverse },
        ]"
        @click.stop="openCarouselModal(content.images)"
        v-reveal
      >
        <ResponsiveImage
          :media="content.images[0]"
          class="object-cover xl:w-full xl:h-full aspect-video"
        />
        <span
          class="flex justify-center items-center absolute bottom-4 lg:bottom-9 left-4 lg:left-auto lg:right-8 text-pink transition-[left_right_bottom]"
        >
          <IconSprite id="gallery" class="absolute text-[25px] text-dustrose" />
          <IconSprite id="symbol" class="text-[50px]" />
        </span>
      </button>
      <div class="xl:text-left">
        <h2
          v-if="content.title"
          class="text-2xl lg:text-3xl font-title uppercase mb-1"
          v-reveal="{ delay: 350 }"
        >
          {{ content.title }}
        </h2>
        <p
          v-if="content.subtitle"
          class="text-sm font-title uppercase mb-5 text-pink"
          v-reveal="{ delay: 400 }"
        >
          {{ content.subtitle }}
        </p>
        <p v-if="content.description" v-reveal="{ delay: 450 }" class="whitespace-break-spaces">
          {{ content.description }}
        </p>
        <SiteLink
          v-if="content.buttons?.length"
          :content="content.buttons[0]"
          class="mt-9 button"
          v-reveal="{ delay: 450 }"
        />
      </div>
    </div>
  </section>
</template>

<script lang="ts">
import { type PropType, toRef } from 'vue'

import ImagesCarousel from '@/components/blocks/ImagesCarousel.vue'
import IconSprite from '@/components/helpers/IconSprite.vue'
import ResponsiveImage from '@/components/helpers/ResponsiveImage.vue'
import SiteLink from '@/components/helpers/SiteLink.vue'
import { useBackgroundColor } from '@/composables/useBackgroundColor.ts'
import { useModalStore } from '@/stores/modal.ts'

export default {
  name: 'TextImageSection',
  components: { IconSprite, ImagesCarousel, ResponsiveImage, SiteLink },
  props: {
    content: {
      type: Object as PropType<TextImageSection>,
      required: true,
    },
  },
  setup(props) {
    return {
      backgroundClasses: useBackgroundColor(toRef(props.content, 'background')),
      openCarouselModal: useModalStore().openCarousel,
    }
  },
}
</script>
